export default __webpack_public_path__ + "static/img-nhs-app--mobile-4b220b94b83051741226d670773c167b.webp";